import { DOCUMENTO_IDS_BS, DOCS_QUE_REQUIEREN_COMPRA_BS } from "../constants/documentos-bs";

export function SidebarBs({
  completedFields,
  pendingFields,
  filesToCorrect,
  showOnlyCorrections,
  activeTab,
  setActiveTab,
  files,
  completedFields2,
  progress,
  progressColor,
  isMenuOpen,
  onEnviarVerificacion,
  idCompraBS,
}) {
  return (
    <div
      className={`w-64 bg-white text-gray-800 shadow-lg ${
        isMenuOpen ? "block" : "hidden"
      } md:block transition-all duration-300 ease-in-out`}
    >
      <div className="p-4 space-y-6">
        {/* Barra de progreso */}
        <div>
          <label className="block text-sm font-semibold text-gray-500">Progreso de Archivos</label>
          <div className="mt-2 flex items-center justify-between">
            <span className="text-sm text-gray-600">{Math.round(progress)}%</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2 mt-1">
            <div
              className="rounded-full h-2 transition-all duration-500 ease-in-out"
              style={{ width: `${progress}%`, backgroundColor: progressColor }}
            />
          </div>
          {progress === 100 && (
            <div className="mt-4 text-center">
              <button
                onClick={onEnviarVerificacion}
                className="bg-green-500 text-sm text-white py-2 px-4 rounded shadow hover:bg-green-600 transition-transform duration-300 transform hover:scale-105"
              >
                Enviar verificación
              </button>
            </div>
          )}
        </div>

        {showOnlyCorrections ? (
          <CorrectionsListBs
            filesToCorrect={filesToCorrect}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            files={files}
            completedFields2={completedFields2}
          />
        ) : (
          <>
            <PendingListBs
              pendingFields={pendingFields}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              files={files}
              idCompraBS={idCompraBS}
            />
            {completedFields.length > 0 && (
              <CompletedListBs
                completedFields={completedFields}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                files={files}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
}

function CorrectionsListBs({ filesToCorrect, activeTab, setActiveTab, files, completedFields2 }) {
  return (
    <div>
      <h3 className="text-sm font-medium text-red-500">Campos a Corregir</h3>
      <ul className="mt-2 space-y-1">
        {filesToCorrect.map((item) => {
          const fileCount = files[item]?.filter((f) => !f?.url).length || 0;
          const isSelected = activeTab === item;
          const numeroDoc = DOCUMENTO_IDS_BS[item];
          const esOpcional = numeroDoc >= 16 && numeroDoc <= 25;
          const esCompletado = completedFields2.includes(item);

          return (
            <li key={item}>
              <a
                href="#"
                onClick={(e) => { e.preventDefault(); setActiveTab(item); }}
                className={`flex justify-between items-center text-sm py-2 px-3 rounded-lg transition-all duration-200 ${
                  isSelected && esCompletado
                    ? "bg-green-600 text-white shadow-lg"
                    : isSelected
                    ? esOpcional
                      ? "bg-yellow-600 text-white shadow-lg"
                      : "bg-red-600 text-white shadow-lg"
                    : esCompletado
                    ? "text-green-600 hover:bg-green-100 hover:text-green-800"
                    : esOpcional
                    ? "text-yellow-600 hover:bg-yellow-100 hover:text-yellow-800"
                    : "text-red-600 hover:bg-red-100 hover:text-red-800"
                }`}
              >
                {item}
                <div className="flex items-center gap-1">
                  {esOpcional && <span className="text-xs">(Opcional)</span>}
                  {fileCount > 0 && (
                    <span
                      className={`text-xs font-bold px-2 py-1 rounded-full ${
                        isSelected
                          ? esOpcional ? "bg-white text-yellow-600" : "bg-white text-red-600"
                          : esOpcional ? "bg-yellow-500 text-white" : "bg-red-500 text-white"
                      }`}
                    >
                      +{fileCount}
                    </span>
                  )}
                  {esCompletado && <span className="text-green-500 font-bold">✓</span>}
                </div>
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

function PendingListBs({ pendingFields, activeTab, setActiveTab, files, idCompraBS }) {
  return (
    <div>
      <h3 className="text-sm font-medium text-gray-500">Campos Pendientes</h3>
      <ul className="mt-2 space-y-1">
        {pendingFields.map((item) => {
          const fileCount = files[item]?.length || 0;
          const isSelected = activeTab === item;
          const faltaPrefactura = !idCompraBS && DOCS_QUE_REQUIEREN_COMPRA_BS.includes(item);
          return (
            <li key={item}>
              <a
                href="#"
                onClick={(e) => { e.preventDefault(); setActiveTab(item); }}
                className={`flex justify-between items-center text-sm py-2 px-3 rounded-lg transition-all duration-200 ${
                  isSelected
                    ? "bg-blue-600 text-white shadow-lg"
                    : "text-gray-600 hover:bg-blue-100 hover:text-blue-800"
                }`}
              >
                <span className="flex items-center gap-1">
                  {item}
                  {faltaPrefactura && (
                    <span title="Falta ingresar la prefactura">⚠️</span>
                  )}
                </span>
                {fileCount > 0 && (
                  <span
                    className={`text-xs font-bold px-2 py-1 rounded-full ${
                      isSelected ? "bg-white text-blue-600" : "bg-green-500 text-white"
                    }`}
                  >
                    +{fileCount}
                  </span>
                )}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

function CompletedListBs({ completedFields, activeTab, setActiveTab, files }) {
  return (
    <div>
      <h3 className="text-sm font-medium text-gray-500">Campos Completados</h3>
      <ul className="mt-2 space-y-1">
        {completedFields.map((item) => {
          const fileCount = files[item]?.length || 0;
          const isSelected = activeTab === item;
          return (
            <li key={item}>
              <a
                href="#"
                onClick={(e) => { e.preventDefault(); setActiveTab(item); }}
                className={`flex justify-between items-center text-sm py-2 px-3 rounded-lg transition-all duration-200 ${
                  isSelected
                    ? "bg-blue-600 text-white shadow-lg"
                    : "text-gray-600 hover:bg-blue-100 hover:text-blue-800"
                }`}
              >
                {item}
                <div className="flex items-center">
                  {fileCount > 0 && (
                    <span
                      className={`text-xs font-bold px-2 py-1 rounded-full ${
                        isSelected ? "bg-white text-blue-600" : "bg-green-500 text-white"
                      }`}
                    >
                      +{fileCount}
                    </span>
                  )}
                  <span className="ml-2 text-green-500 font-bold">✓</span>
                </div>
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
